export default __webpack_public_path__ + "static/media/workoutKeto.c5b61630.svg";